import React from 'react';
import { filterMenuByRole } from '../../libs/user-lib';
import DefaultEventAdminsComponent from './DefaultEventAdminsComponent';
import { useAppContext } from '../../libs/context-lib';
import { Flex } from 'reflexbox';
import { Menu } from 'boss-ui';


export default function DefaultAdminsTab() {
  const { state } = useAppContext();

  return (
    <Flex flexDirection="column">
      <Menu menuItems={filterMenuByRole(state.user)} />
      <Flex width={1} justifyContent="center"  mt="30px" mb="5%">
        <DefaultEventAdminsComponent />
      </Flex>
    </Flex>
  );
};
